import { XdbDispatcher } from "@uniformdev/tracking";
export function getDispatchersForXdbDestinations(destinations, logger) {
  var dispatchers = [];
  destinations.forEach(function (destination) {
    var dispatcher = getDispatcherForXdb(destination, logger);
    if (!dispatcher) {
      logger.error("useSitecoreTracker - Unable to get dispatcher for destination.", destination);
      return;
    }
    dispatchers.push(dispatcher);
  });
  return dispatchers;
}
function getDispatcherForXdb(destination, _logger) {
  if (!destination) {
    return;
  }
  return new XdbDispatcher(destination);
}